import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GruppeTierFilterDialogComponent } from '../gruppe-tier-filter-dialog/gruppe-tier-filter-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Gruppe } from '../../../gruppen/classes/gruppe';
import { TierFilterSettings } from '../gruppe-tier-filter-dialog/classes/tier-filter-settings';
import { TierFilterSettingsPersistence } from '../gruppe-tier-filter-dialog/classes/tier-filter-settings-persistence';
import { TierFilterDialogResult } from '../gruppe-tier-filter-dialog/classes/tier-filter-dialog-result';
import { KieneBackendApiService } from '../../../../services/backend-api/kiene-backend-api.service';
import { Observable, Subject } from 'rxjs';

@Component({
    selector: 'kiene-gruppe-tier-filter-button',
    templateUrl: './gruppe-tier-filter-button.component.html',
    styleUrls: ['./gruppe-tier-filter-button.component.scss'],
})
export class GruppeTierFilterButtonComponent {
    @Input('gruppe') gruppe: Gruppe;
    @Input() gruppeIds: number[] = [];
    @Input('tierFilterSettings') filterSettings: TierFilterSettings = new TierFilterSettings();
    @Input() respectFilterSettingsVisibility = false;
    @Input() disableTierFilterSelection = false;
    /** When true, saves filter to speicher on apply/clear (group-details only). */
    @Input() persistToSpeicher = false;
    @Input() saveFilterEnabled = false;
    @Output() saveFilterEnabledChange = new EventEmitter<boolean>();
    @Output('filterSelected') filterSelected: EventEmitter<TierFilterSettings> = new EventEmitter<TierFilterSettings>();

    constructor(
        private readonly dialog: MatDialog,
        private readonly api: KieneBackendApiService,
    ) {}

    public openFilterDialog(options?: { filterSettings?: TierFilterSettings; info?: string }): Observable<boolean> {
        const sub = new Subject<boolean>();

        let tfs: TierFilterSettings;
        if (options?.filterSettings) {
            tfs = options.filterSettings;
        } else {
            tfs = this.filterSettings.clone();
            if (!this.respectFilterSettingsVisibility) {
                tfs.showAbgangslisten = true;
                tfs.showAbteile = true;
                tfs.showEinstalldatum = true;
                tfs.showFilter = true;
                tfs.showGeschlechter = true;
                tfs.showRassen = true;
                tfs.showReklamationen = true;
                tfs.showViehhaendler = true;
                tfs.showBetriebskontakte = true;
                tfs.showHerkunftsbetriebe = true;
            }
        }

        const dialogRef = this.dialog.open(GruppeTierFilterDialogComponent, {
            width: '90vw',
            data: {
                gruppe: this.gruppe,
                gruppeIds: this.gruppeIds,
                filterSettings: tfs,
                info: options?.info ? options?.info : null,
                disableTierFilterSelection: this.disableTierFilterSelection,
                showSaveFilterOption: this.persistToSpeicher,
                saveFilterEnabled: this.saveFilterEnabled,
            },
        });
        dialogRef.afterClosed().subscribe({
            next: (res: TierFilterDialogResult | TierFilterSettings | null) => {
                const settings = TierFilterDialogResult.unwrap(res);
                if (settings) {
                    settings.normalize();
                    this.filterSettings = settings;
                    this.filterSelected.emit(this.filterSettings);
                    if (this.persistToSpeicher && res && typeof res === 'object' && 'saveToSpeicher' in res) {
                        this.saveFilterEnabled = !!(res as TierFilterDialogResult).saveToSpeicher;
                        this.saveFilterEnabledChange.emit(this.saveFilterEnabled);
                        TierFilterSettingsPersistence.save(
                            this.api,
                            this.filterSettings,
                            this.saveFilterEnabled,
                        ).subscribe();
                    }
                }
                sub.next(true);
            },
        });
        return sub;
    }
}
